var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex overflow-hidden"},[_c('b-icon',{attrs:{"icon":"file-earmark-medical"}}),_c('div',{staticClass:"ml-1 text-nowrap"},[_vm._v(" "+_vm._s(_vm.document.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }